var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c, _d;
import { makeAutoObservable } from "mobx";
import { inject } from "tsyringe";
import { perRestaurant } from "../di";
import { Restaurant } from "./Restaurant";
import { Payment } from "./Payment";
import { OrderReceiver } from "./OrderReceiver";
import { FulfillmentInstructions, FulfillmentInstructionsToken, } from "./FulfillmentInstructions";
let ServiceFeeSettingsService = class ServiceFeeSettingsService {
    constructor(restaurant, payment, orderReceiver, fulfillmentInstructions) {
        this.restaurant = restaurant;
        this.payment = payment;
        this.orderReceiver = orderReceiver;
        this.fulfillmentInstructions = fulfillmentInstructions;
        makeAutoObservable(this);
    }
    get applicableQuote() {
        const quote = this.restaurant.orderingPolicy.serviceFeeQuote;
        if (quote === null) {
            return null;
        }
        if (this.payment.method !== "Online") {
            return null;
        }
        if (this.orderReceiver.invoiceRequest !== null) {
            return null;
        }
        if (quote.deliveryOnly && !this.fulfillmentInstructions.isDelivery) {
            return null;
        }
        return quote;
    }
    get percentage() {
        var _a, _b;
        return (_b = (_a = this.applicableQuote) === null || _a === void 0 ? void 0 : _a.percentage) !== null && _b !== void 0 ? _b : null;
    }
    get bounds() {
        return this.applicableQuote;
    }
};
ServiceFeeSettingsService = __decorate([
    perRestaurant(),
    __param(3, inject(FulfillmentInstructionsToken)),
    __metadata("design:paramtypes", [typeof (_a = typeof Restaurant !== "undefined" && Restaurant) === "function" ? _a : Object, typeof (_b = typeof Payment !== "undefined" && Payment) === "function" ? _b : Object, typeof (_c = typeof OrderReceiver !== "undefined" && OrderReceiver) === "function" ? _c : Object, typeof (_d = typeof FulfillmentInstructions !== "undefined" && FulfillmentInstructions) === "function" ? _d : Object])
], ServiceFeeSettingsService);
export { ServiceFeeSettingsService };
